<script setup>
defineProps({
    message: {
        type: String,
        required: false,
    },
})
</script>

<template>
    <ul v-show="message">
        <li class="list-inside list-disc rounded-lg text-sm text-red-500">
            {{ message }}
        </li>
    </ul>
</template>
